import messages from '../../messages';

export const validateProfessionType = (value, formatMessage) => {
  let fieldError = '';

  if (!value || value.trim() === '') {
    fieldError = formatMessage(messages['registration.profession.error.required']);
  }

  return fieldError;
};
